export const Device = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Embedded: 'embedded',
    Browser: undefined,
}

export const DeviceType = {
    PC: 'PC',
    MOBILE: 'MOBILE',
} as const

export const Browser = {
    Chrome: 'Chrome',
    Firefox: 'Firefox',
    Opera: 'Opera',
    Yandex: 'Yandex',
    Safari: 'Safari',
    InternetExplorer: 'Internet Explorer',
    Edge: 'Edge',
    Chromium: 'Chromium',
    IE: 'IE',
    MobileSafari: 'Mobile Safari',
    EdgeChromium: 'Edge Chromium',
    MIUI: 'MIUI Browser',
    SamsungBrowser: 'Samsung Browser',
}

export const BrowserApp = {
    CHROME: 'CHROME',
    FIREFOX: 'FIREFOX',
    SAFARI: 'SAFARI',
    OPERA: 'OPERA',
    IE: 'IE',
    EDGE: 'EDGE',
    ETC: 'ETC',
} as const

export const OS = {
    IOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'Windows Phone',
    Windows: 'Windows',
    MAC_OS: 'Mac OS',
}

export const OSType = {
    ANDROID: 'ANDROID',
    ETC: 'ETC',
    IOS: 'IOS',
    LINUX: 'LINUX',
    MAC_OS: 'MAC_OS',
    WINDOWS: 'WINDOWS',
} as const

export const MobileApp = {
    NAVER: 'NAVER',
    NAVER_PAY: 'NAVER_PAY',
    NAVER_CAFE: 'NAVER_CAFE',
    /** 네이버 쇼핑 앱 */
    NAVER_SHOPPING: 'NAVER_SHOPPING',
    NAVER_WEBTOON: 'NAVER_WEBTOON',
    SERIES: 'SERIES',
    VIBE: 'VIBE',
    CHZZK: 'CHZZK',
    NAVER_MAP: 'NAVER_MAP',
    UNKNOWN: 'UNKNOWN',
} as const
type MobileAppType = Constant<typeof MobileApp>

/** UA 키워드 별 앱 타입 목록 */
export const MobileApps: Record<string, MobileAppType> = {
    search: MobileApp.NAVER,
    pay: MobileApp.NAVER_PAY,
    cafe: MobileApp.NAVER_CAFE,
    navershopping: MobileApp.NAVER_SHOPPING,
    navershoppingbrowser: MobileApp.NAVER_SHOPPING,
    'shopping-sdk': MobileApp.NAVER_SHOPPING,
    map: MobileApp.NAVER_MAP,
} as const
